
import _ from 'lodash'

export default {
    props: {
        clientIds: {
            // null means "unscoped, search everything"; [] means "scope to these
            // clients, and there are none yet". Treating [] as unscoped is what made
            // the search page show every client's appointments while its own results
            // were still loading.
            type: Array,
            required: false,
            default: null,
        },
        showLabel: {
            type: Boolean,
            default: true,
        },
        showFilters: {
            type: Boolean,
            default: false,
        },
        perPage: {
            type: Number,
            default: 5,
        },
        query: {
            type: String,
            default: null
        },
    },
    data () {
        return {
            loading: false,
            appointments: [],
            calendars: [],
            calendarId: null,
            fresh: false,
            showCancelModal: false,
            cancellingAppointment: null,
            cancelForm: {
                no_email: false,
                admin: true,
                cancel_note: '',
                no_show: false
            },
            currentPage: 1,
        }
    },
    async fetch () {
        if (this.showFilters) await this.fetchCalendars()
        await this.fetchAppointments()
    },
    computed: {
        paginatedAppointments () {
            if (!this.appointments?.length) {
                return []
            }
            const start = (this.currentPage - 1) * this.perPage
            const end = start + this.perPage
            return this.appointments.slice(start, end)
        }
    },
    watch: {
        clientIds: {
            deep: true,
            handler: _.debounce(function () {
                // Refetch on any change, including to an empty list. The old
                // `if (val?.length)` meant narrowing to zero clients left the
                // previous, wider results sitting on screen.
                this.fetchAppointments()
            }, 300)
        },
        query: _.debounce(function () {
            this.fetchAppointments()
        }, 300),
    },
    mounted () {
        return this.$fetch()
    },
    methods: {
        async fetchCalendars () {
            this.calendars = await this.$api.getAppointmentsCalendars()
            this.calendarId = this.calendars.filter(c => c.id === this.user.id)[0]?.calendar_id
        },
        async fetchAppointments (fresh) {
            // Scoped to an empty set: nothing to ask for. Skipping the request also
            // avoids a flash of unscoped results before the real ones arrive.
            if (Array.isArray(this.clientIds) && !this.clientIds.length) {
                this.appointments = []
                this.loading = false
                return
            }
            this.loading = true
            this.appointments = await this.$api.getUpcomingAppointments({
                client_ids: this.clientIds,
                calendar_id: this.calendarId,
                fresh: fresh === true || this.fresh,
                query: this.query,
            })
            this.loading = false
            this.currentPage = 1
        },
        initiateCancel (appointment) {
            this.cancellingAppointment = appointment
            this.cancelForm = {
                no_email: false,
                admin: false,
                cancel_note: '',
                no_show: false
            }
            this.showCancelModal = true
        },
        async confirmCancel (bvModalEvt) {
            bvModalEvt.preventDefault()
            try {
                this.loading = true
                await this.$api.cancelAppointment(this.cancellingAppointment.id, this.cancelForm)
                this.showCancelModal = false
                this.cancellingAppointment = null
                await this.fetchAppointments(true)
                this.$bvToast.toast('Appointment cancelled successfully', {
                    title: 'Success',
                    variant: 'success',
                    solid: true
                })
            } catch (e) {
                this.loading = false
                this.$bvToast.toast('Failed to cancel appointment', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                })
            }
        }
    }
}
